(function($){
  /**
   * more ボタン
   */
	var sheetID = "display_controller_css";
	var sheet = OH.dynamicCSS.register(sheetID, true);
	if(!!sheet){
		sheet.addRule("[data-display-controlled]{ display : none; }");
		sheet.addRule("[data-display-controlled].is-block{ display : inline-block; }");
	}

	OH.displayController = function($parent){
		var initialDisplayLength = $parent.data("displaySize") - 0 || 4;
		var moreDisplayLength = $parent.data("displayMore") - 0 || initialDisplayLength;
		var currentSize = initialDisplayLength;
		var $targets = $parent.find('[data-display-controlled]');
		var $mores = $parent.find('a[href$="#show:more"]');
		
		var show = function(){
			$.each($targets, function(index){
				if(index < currentSize){
					$(this).addClass("is-block");
				}
				else{
					$(this).removeClass("is-block");
				}
			});
			
			if($targets.length <= currentSize){
				$mores.each(function(){
					$(this).hide();
				});
			}
			OH.settings.heightControl.refined($parent);
		};
		
		$mores.each(function(){
			$(this).on("click", function(event){
				event.preventDefault();
				currentSize += moreDisplayLength;
				show();
			});
		});
		
		show();
		OH.settings.heightControl.refined($parent);
		
		$(window).on("load", function(){
			OH.settings.heightControl.refined($parent);
		});
		window.setTimeout(function(){
			OH.settings.heightControl.refined($parent);
		}, 5555);
	}

})(jQuery);
